import { ElementPosition, TranslatePercentage } from './Types';

export const getPositionAndTranslatePercentage = (
  top: number,
  left: number,
  height: number,
  width: number,
  position?: 'top' | 'right' | 'left' | 'bottom',
) => {
  /*
   * top=> top: top + RANGE, left: left + width / 2, translate(0,-100%)
   * right=> top: top  + height/2, left: width + RANGE, translate(0,-50%)
   * bottom=> top: height + RANGE, left: left + width / 2, translate(0,100%)
   * left => top: top + height/2, left: left, translate(0, -50%)
   */
  let elementPosition = { top: '0px', left: '0px' } as ElementPosition;
  let percentageTranslate = { x: 0, y: 0 } as TranslatePercentage;

  switch (position) {
    case 'top':
      if (left - width / 2 <= 0) {
        elementPosition = { top: `${top - 40}px`, left: `${left}px` };
        percentageTranslate = { x: 0, y: -100 };
      } else {
        elementPosition = {
          top: `${top - 40}px`,
          left: `${left + width / 2}px`,
        };
        percentageTranslate = { x: -50, y: -100 };
      }
      break;

    case 'right':
      if (top - height / 2 <= 0) {
        elementPosition = { top: `${top}px`, left: `${left + width + 12}px` };
        percentageTranslate = { x: 0, y: 0 };
      } else {
        elementPosition = {
          top: `${top + height / 2}px`,
          left: `${left + width + 12}px`,
        };
        percentageTranslate = { x: 0, y: -50 };
      }
      break;

    case 'bottom':
      if (left - width / 2 <= 0) {
        elementPosition = { top: `${top + height + 12}px`, left: `${left}px` };
        percentageTranslate = { x: 0, y: 0 };
      } else {
        elementPosition = {
          top: `${top + height + 12}px`,
          left: `${left + width / 2}px`,
        };
        percentageTranslate = { x: -50, y: 0 };
      }
      break;

    case 'left':
      if (top - height / 2 <= 0) {
        elementPosition = { top: `${top}px`, left: `${left - 12}px` };
        percentageTranslate = { x: -100, y: 0 };
      } else {
        elementPosition = {
          top: `${top + height / 2}px`,
          left: `${left - 12}px`,
        };
        percentageTranslate = { x: -100, y: -50 };
      }
      break;
    default:
    // do nothing
  }

  return { elementPosition, percentageTranslate };
};
